import api from './config';

// 获取天气配置列表
export const getWeatherConfigs = async () => {
  return api.get('/weather/configs');
};

// 获取单个天气配置
export const getWeatherConfig = async (configId) => {
  return api.get(`/weather/configs/${configId}`);
};

// 创建天气配置
export const createWeatherConfig = async (data) => {
  return api.post('/weather/configs', data);
};

// 更新天气配置
export const updateWeatherConfig = async (configId, data) => {
  return api.put(`/weather/configs/${configId}`, data);
};

// 删除天气配置
export const deleteWeatherConfig = async (configId) => {
  return api.delete(`/weather/configs/${configId}`);
};

// 获取当前启用的天气 API key（内部接口）
export const getActiveWeatherKey = async () => {
  return api.get('/weather/key');
};

// 测试天气 API
export const testWeatherAPI = async (configId = null) => {
  const data = configId ? { config_id: configId } : {};
  return api.post('/weather/test', data);
};

